module.exports = __webpack_public_path__ + "static/img/contant_1.4bd3bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_1.jpg
// module id = L8YF
// module chunks = 0